import React from 'react';
import { InitialsAvatarStyles as styles } from '../css/styles';
import { getInitials, getInitialsColor } from '../utils/avatar';
import classNames from 'classnames';

interface InitialsAvatarProps {
  name?: string | null;
  surname?: string | null;
  size: number;
  fontSize?: string;
  className?: string;
  onClick?: () => void;
}

const InitialsAvatar: React.FC<InitialsAvatarProps> = ({ name, surname, size, fontSize, className, onClick }) => {
  return (
    <div
      className={classNames(styles.initialsAvatar, className)}
      onClick={onClick}
      style={{
        width: `${size}rem`,
        height: `${size}rem`,
        fontSize: fontSize ?? `${size * 0.4}rem`,
        backgroundColor: getInitialsColor(name, surname),
        cursor: onClick ? 'pointer' : undefined,
      }}
    >
      {getInitials(name, surname)}
    </div>
  );
};

export default InitialsAvatar;
